import { render, staticRenderFns } from "./_index1.vue?vue&type=template&id=0b46a074&scoped=true"
import script from "./_index1.vue?vue&type=script&lang=js"
export * from "./_index1.vue?vue&type=script&lang=js"
import style0 from "./_index1.vue?vue&type=style&index=0&id=0b46a074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b46a074",
  null
  
)

export default component.exports